export default __webpack_public_path__ + "static/media/add-avatar.c4058906.svg";